// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","overlayContainer":"tmCT9","inline":"_6jyJL","title":"dTbVM","description":"nUUr1","button":"y5nMK","modal":"XFL9g"};